<template>
  <component
    :is="tag"
    class="hkl-hover-tooltip-outer"
  >
    <slot />
    <div class="tips-content-outer">
      <slot name="tips" />
    </div>
  </component>
</template>
<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
}
</script>
<style lang="scss" scoped>
.hkl-hover-tooltip-outer {
  position: relative;
  .tips-content-outer {
    min-width: 50%;
    display: none;
    background-color: #F0F0F0;
    color: #0C3A58 ;
    padding: 2px 5px;
    border-radius: 6px;
    position: absolute;
    z-index: 999;
    left: 0;
    border: 1px solid rgb(142, 138, 138);
    box-shadow: 3px 3px 3px rgb(142, 138, 138);
  }
  &:hover {
    .tips-content-outer {
      display: block;
    }
  }
}
</style>
